import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  BehaviorSubject,
  catchError,
  forkJoin,
  map,
  Observable,
  throwError,
} from 'rxjs';
import {
  PaybevInvestmentStatus,
  responseMessageStatus,
} from 'src/@shared/enum';
import { environment } from 'src/environments/environment';
import { DatePipe, Location } from '@angular/common';
import moment from 'moment';
import { APIHandlerService } from './apihandler.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import {
  buildAuthorizationTimezoneHeaders,
  buildFormAuthorizationHeaderOnly,
  buildJsonAuthHeaders,
  buildJsonAuthHeadersWithCapitalAuthorization,
  stripBearerPrefix,
} from './common-request-headers.util';
import { buildApiUrl, buildBodyRequestOptions } from './common-http.util';
import { getBearerToken } from 'src/@shared/storage/app-storage';
import { clearLocalStoragePreserving } from 'src/@shared/auth/auth-state';
@Injectable({
  providedIn: 'root',
})
export class CommonService {
  //#region properties
  isSpinning = false;
  // userLoggedIn: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  calcUserIdleTime: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  /** Profile picture URL, or null. Emitted by the profile drawer so the header avatar follows it. */
  profilePicture: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  pendingCountInvestment: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  underReviewCountInvestment: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  pendingCountExpense: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  underReviewCount: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  FetchFavSites: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  getFilters: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  totalData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  fetchDataAfterAutoLogin: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  paybevInvestmentStatusArray = Object.keys(PaybevInvestmentStatus)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      text: key.replace(/([A-Z])/g, ' $1').trim(),
      value: PaybevInvestmentStatus[key as keyof typeof PaybevInvestmentStatus],
    }));
  //#endregion

  //#region functions
  /**
   *To do multiple POST call at same time and get result once all done the API response.
   * @param URLs_WithBody Contain array of url and body parts, Like [{ url : 'www.gmail.com', body : ''},{ url: 'www.gmail.com', body : ''}].
   * @param Options Give HTTP options Like http headers. */
  API_Post_ForkJoin(
    URLs_WithBody: Array<{ url: any; body: any }>,
    Options?: any
  ): Observable<any> {
    let observableBatch = [];
    for (let i = 0; i < URLs_WithBody.length; i++) {
      const element = URLs_WithBody[i];
      observableBatch.push(
        this._httpClient
          .post<any>(
            buildApiUrl(element.url),
            element.body,
            Options
          )
          .pipe(
            map((res) => {
              return res;
            }),
            catchError((err) => {
              this.errorHandling(err, element.url);
              // this.displayLoader(false);
              return throwError(err);
            })
          )
      );
    }
    return forkJoin(observableBatch);
  }

  /**
   * To do multiple GET call at same time and get result once all done the API response.
   * @param URL_Array - Contain array of urls, Like ['www.gmail.com', 'www.gmail.com'].
   * @param Options - Give HTTP options Like http headers.
   */
  API_GET_ForkJoin(
    URL_Array: any,
    isLoader: Boolean = true,
    Options?: any
  ): Observable<any> {
    let hd = this.GetHeader();
    if (isLoader) {
      // this.displayLoader(true);
    }
    let observableBatch: any = [];
    URL_Array.forEach((url: any) => {
      if (url) {
        observableBatch.push(
          this._httpClient
            .get<any>(
              buildApiUrl(url),
              Options ? Options : { headers: hd }
            )
            .pipe(
              map((res) => {
                return res;
              }),
              catchError((err) => {
                this.errorHandling(err, url);
                // this.displayLoader(false);
                return throwError(err);
              })
            )
        );
      }
    });
    return forkJoin(observableBatch);
  }

  /**
   * Use this common method for all the GET api
   * @param Url Just pass url after /api/. Predefine url will take from environment.
   * @param isLoader If you dont want to display loader in any API call send FALSE.
   * @param Options Set any other options if required.
   * @returns
   */
  API_GET(Url: any, isLoader: Boolean = true, Options?: any): Observable<any> {
    let hd = this.GetHeader();
    if (hd) {
      if (isLoader) {
        this.isSpinning = true;
        // this.displayLoader(true);
      }
      return this._httpClient
        .get<any>(
          //`${Url}`,
          buildApiUrl(Url),
          Options ? Options : { headers: hd }
        )
        .pipe(
          map((data) => {
            this.isSpinning = false;
            // this.changeDetection.detectChanges();
            //this.displayLoader(false);
            return data;
          }),
          catchError((err) => {
            this.isSpinning = false;
            //this.displayLoader(false);
            this.errorHandling(err, Url);
            return throwError(err);
          })
        );
    } else {
      return throwError('BearerToken is not present');
    }
  }

  API_GETCOUNTRY(Url: any): Observable<any> {
    return this._httpClient.get<any>(`${Url}`);
  }

  /** Build headers like GetHeader but using an explicit token (used for SSO ValidateToken). */
  BuildHeaderWithToken(rawToken: string | null | undefined): HttpHeaders | undefined {
    if (!rawToken) {
      return;
    }
    const token = stripBearerPrefix(rawToken);
    return buildJsonAuthHeadersWithCapitalAuthorization(token, this._datepipe);
  }

  /** Post API Method.
   * @param Url - Just pass url after /api/. Predefine url will take from environment
   * @param Body - Pass body parameter in json. Ex : { id : 1, name : Sushma, occupation : Angular Developer}
   */

  API_POST(
    Url: any,
    Body?: any,
    isLoader: Boolean = true,
    Options?: any,
    responseType?: any
  ): Observable<any> {
    let hd = this.GetHeader();
    // if (hd) {
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .post<any>(
        buildApiUrl(Url),
        Body,
        buildBodyRequestOptions({ headers: hd, responseType, options: Options })
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
    // } else {
    //   return throwError('BearerToken is not present');
    // }
  }
  /** POST without Bearer token (e.g. SSO ValidateToken). Caller passes body and options (headers, params). */
  API_POST_NoAuth(
    Url: string,
    Body: any,
    Options?: { params?: any; headers?: HttpHeaders }
  ): Observable<any> {
    const httpOptions = Options || {};
    
    return this._httpClient
      .post<any>(buildApiUrl(Url), Body, httpOptions)
      .pipe(
      map((data) => data),
      catchError((err) => {
        this.errorHandling(err, Url);
        return throwError(err);
      })
    );
  }

  /** Post API Method.
   * @param Url - Just pass url after /api/. Predefine url will take from environment
   * @param Body - Pass body parameter in json. Ex : { id : 1, name : Sushma, occupation : Angular Developer}
   */
  API_POSTFileUpload(
    Url: any,
    Body?: any,
    isLoader: Boolean = true,
    Options?: any,
    responseType?: any
  ): Observable<any> {
    let hd = this.GetFormHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .post<any>(
        buildApiUrl(Url),
        Body,
        buildBodyRequestOptions({ headers: hd, responseType, options: Options })
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }

  API_PUT(
    Url: any,
    Body: any,
    isLoader: Boolean = true,
    Options?: any,
    responseType?: any
  ): Observable<any> {
    let hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .put<any>(
        buildApiUrl(Url),
        Body,
        buildBodyRequestOptions({ headers: hd, responseType, options: Options })
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }
  /** Delete API Method.
   * @param Url - Just pass url after /api/. Predefine url will take from environment
   */
  API_DELETE(
    Url: any,
    isLoader: Boolean = true,
    Options?: any
  ): Observable<any> {
    let hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .delete<any>(
        buildApiUrl(Url),
        Options ? Options : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          //this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }
  API_DELETE_RECORDS(
    Url: any,
    Body: any,
    isLoader: Boolean = true,
    Options?: any,
    responseType?: any
  ): Observable<any> {
    let hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .post<any>(
        buildApiUrl(Url),
        Body,
        buildBodyRequestOptions({ headers: hd, responseType, options: Options })
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }

  /**
   * This method is used to show/hide loader
   * @param value pass True / False in value parameter to show / hide the loader respectively
   * Here is the link to npm used : https://www.npmjs.com/package/ngx-spinner
   */
  // displayLoader(value: any) {
  //   value
  //     ? this._spinner.show(undefined, {
  //         type: 'ball-pulse',
  //         size: 'small',
  //         bdColor: 'rgb(0,0,0,0.2)',
  //         color: '#00000',
  //         fullScreen: true,
  //       })
  //     : this._spinner.hide();
  // }

  /**
   * @param err pass here error  for handle by status
   */
  errorHandling(err: any, URL: any) {
    console.log(err);
    if (err.status == 401 || err.status == 0) {
      this.displayMessage(
        'warning',
        "You're not authorized for the requested page"
      );
      this.logOut();
    }
    if (err.status == 0) {
      this.displayMessage('warning', 'Session expired, please re-login');
      this.logOut();
    }
    if (err.status == 403) {
      this.displayMessage(
        'warning',
        "You're not authorized for the requested page"
      );
      this.location.back();
    }
    if (
      err.status != 200 &&
      err.status != 403 &&
      err.status != 401 &&
      err.status != 0
    ) {
      this._router.navigate(['/something-wrong']);
    }
  }

  // #endregion

  /**
   * SetCookie Method (Locally Value set)
   * @param cname - CookieName Like 'Lst_Projects'
   * @param cvalue - CookieValue Like 'abc'
   * @param exdays - CookieExpireDays Like 360
   */
  setCookie(cname: any, cvalue: any, exdays: number) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie =
      cname +
      '=' +
      cvalue +
      ';' +
      expires +
      ';domain=' +
      location.hostname.split('.').reverse().splice(0, 2).reverse().join('.') +
      ';path=/';
    console.log(
      cname +
        '=' +
        cvalue +
        ';' +
        expires +
        ';domain=' +
        location.hostname
          .split('.')
          .reverse()
          .splice(0, 2)
          .reverse()
          .join('.') +
        ';path=/'
    );
  }

  /**
   * GetCookie Method (Value get)
   * @param cname - CookieName Like Lst_Projects
   */
  getCookie(cname: any) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  responseMessage(
    status: responseMessageStatus,
    messageInfo: string,
    duration?: number
  ) {
    if (status === responseMessageStatus.info) {
      this.message.info(messageInfo, {
        nzDuration: duration ? duration : 7000,
      });
    } else if (status === responseMessageStatus.warning) {
      this.message.warning(messageInfo, {
        nzDuration: duration ? duration : 7000,
      });
    } else if (status === responseMessageStatus.error) {
      this.message.error(messageInfo, {
        nzDuration: duration ? duration : 7000,
      });
    } else if (status === responseMessageStatus.success) {
      this.message.success(messageInfo, {
        nzDuration: duration ? duration : 7000,
      });
    }
  }

  /**
   * get the request header to pass in apis
   * @returns headers
   */
  GetHeader() {
    const tokenObj = this.getTokenObj();
    if (tokenObj) {
      return buildJsonAuthHeaders(tokenObj, this._datepipe);
    }
    return;
  }
  GetFormHeader() {
    const tokenObj = this.getTokenObj();
    if (tokenObj) {
      return buildFormAuthorizationHeaderOnly(tokenObj);
    } else {
      return;
    }
  }

  /**
   * get token object function
   */
  getTokenObj() {
    var localtoken = getBearerToken();
    if (localtoken) {
      return localtoken;
    } else {
      return null;
    }
  }
  /**
   *
   * @param formGroup pass formGroup name which form you want to validate
   */
  public markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control.invalid) {
        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: true });
      }
    });
  }
  GetAuthorizationHeader() {
    const tokenObj = this.getTokenObj();
    if (tokenObj) {
      return buildAuthorizationTimezoneHeaders(tokenObj, this._datepipe);
    }
    return;
  }
  displayMessage(type: string, message: string) {
    this.message.create(type.toString(), message, {
      nzDuration: 7000,
    });
    // this.notification.create(type, message, 'message', {
    //   nzDuration: 60000,
    // });
  }

  checkAlphabets(event: any) {
    var regex = new RegExp('^[a-zA-Z]+$');
    var strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkAlphabetsWithSpace(event: any) {
    var regex = new RegExp('^[a-zA-Z ]+$');
    var strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkAlphabetsWithSpaceCommaNumbers(event: any) {
    var regex = new RegExp("^[a-zA-Z0-9 ,.'!&-]+$");
    var strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkAlphaNumerics(event: any) {
    var regex = new RegExp('^[a-zA-Z0-9 ]+$');
    var strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      if (strInput.length == 10 && strInput == '') {
        return false;
      } else {
        return true;
      }
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkDateInput(event: any) {
    var regex = new RegExp('^[0-9/]+$');
    var strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      if (strInput.length == 10 && strInput == '') {
        return false;
      } else {
        return true;
      }
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkUserName(event: any) {
    var regex = new RegExp('^[a-zA-Z0-9]+$');
    var strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkNumbers(event: any) {
    var regex = new RegExp('^[0-9]+$');
    var strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (regex.test(strInput)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkDecimalNumbers(event: any, value: any) {
    var regex = new RegExp('^[0-9.,]+$');
    var strInput = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (!regex.test(strInput)) {
      event.preventDefault();
    }
    if (value) {
      if (value.toString().includes('.')) {
        var regex = new RegExp('^[.]+$');
        var strInput = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );
        if (regex.test(strInput)) {
          event.preventDefault();
        }
      }
    }
  }
  copyToClipboard(text: any) {
    var textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }
  
  logOut() {
    clearLocalStoragePreserving();
    this._router.navigate([`/login`]);
    this.calcUserIdleTime.next(null);
    sessionStorage.clear();
    // this.pendingRequestsService.clearPendingRequests();
    // window.location.reload();
    // location.reload();
    // this.setUserLoggedIn(false);
  }
  getLocalDate(UTCdate: any) {
    return moment.utc(UTCdate).toDate();
    // return this._datepipe.transform(localDate, 'MM/dd/yyyy');
  }
  // setUserLoggedIn(userLoggedIn: boolean) {
  //   this.userLoggedIn.next(userLoggedIn);
  // }

  // getUserLoggedIn(): Observable<boolean> {
  //   return this.userLoggedIn.asObservable();
  // }
  //#endregion
  constructor(
    private _httpClient: HttpClient,
    private _router: Router,
    // private _spinner: NgxSpinnerService,
    private message: NzMessageService,
    private notification: NzNotificationService,
    private location: Location,
    private _datepipe: DatePipe,
    private pendingRequestsService: APIHandlerService
  ) {
    // this.userLoggedIn.next(false);
  }
}
